// 소셜 로그인 provider 식별자.
// 사용자 앱(@oo/user) 과 백엔드(@oo/api) 가 동일 정의를 사용하도록 본 모듈에서 단일하게 노출한다.
// 새 provider 추가 시 본 배열만 갱신하면 양측 타입/검증이 자동 정합된다.

export const SOCIAL_PROVIDERS = ["kakao", "naver", "google"] as const;
export type SocialProviderName = (typeof SOCIAL_PROVIDERS)[number];

// 외부 입력(라우트 path param / URL fragment 등) 으로 들어온 문자열이 알려진 provider 인지 검사.
export function isSocialProviderName(value: unknown): value is SocialProviderName {
  return typeof value === "string" && (SOCIAL_PROVIDERS as readonly string[]).includes(value);
}
